// extracted by mini-css-extract-plugin
export var gif = "_kb-0";